import { Variants } from '@sky-distribution/digital-gp-submission';
import { VariantDictionary } from '@sky-distribution/exw-configuration-service-interfaces';
import { merge } from 'lodash';
import { CalculateServiceEvent, MetaDataServiceEvent, RateServiceEvent } from '../../events';
import { AppStateMachineContext } from '../../types';

export const mergeRateVariants = (
  context: AppStateMachineContext, event: RateServiceEvent,
): AppStateMachineContext => {
  const selectedRating = 0;

  return {
    ...context,
    ratings: event.data.ratings,
    submission: {
      ...context.submission,
      variants: merge([], context.submission?.variants, event.data.ratings?.[selectedRating]?.variants),
    },
  };
};

export const mergeProductMetaData = (
  context: AppStateMachineContext, event: MetaDataServiceEvent,
): AppStateMachineContext => ({
  ...context,
  coveragesMeta: {
    ...merge({}, context.coveragesMeta, event.data.coverageDictionary),
  },
  variantDictionary: merge({}, event.data.variantDictionary as VariantDictionary),
});

export const mergeSelectedVariant = (
  context: AppStateMachineContext, event: CalculateServiceEvent,
) => (context.digitalSubmission?.variants as Variants)?.map((contextVariant) => {
  const variantData = (event.data.variants as Variants)?.find(
    (updatedVariant) => updatedVariant.name === contextVariant.name,
  );

  if (!variantData) {
    return contextVariant;
  }

  const incomingAmount = variantData.price?.amount;
  const contextAmount = contextVariant.price?.amount;
  const keepContextPrice = !(typeof incomingAmount === 'number' && Number.isFinite(incomingAmount) && incomingAmount > 0)
    && typeof contextAmount === 'number'
    && Number.isFinite(contextAmount)
    && contextAmount > 0;

  return {
    ...contextVariant,
    ...variantData,
    ...(keepContextPrice ? { price: contextVariant.price } : {}),
  };
});

export const mergeDigitalGpSubmission = (
  context: AppStateMachineContext, event: CalculateServiceEvent,
): AppStateMachineContext => ({
  ...context,
  digitalSubmission: {
    ...context.digitalSubmission,
    baseData: {
      ...context.digitalSubmission.baseData,
      ...event.data.baseData,
      policyStartDateISO: context.digitalSubmission.baseData?.policyStartDateISO
        ?? event.data.baseData?.policyStartDateISO,
      policyEndDateISO: context.digitalSubmission.baseData?.policyEndDateISO
        ?? event.data.baseData?.policyEndDateISO,
    },
    variants: mergeSelectedVariant(context, event),
  },
  digitalOffers: [...event.data.variants as Variants],
});
